import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { RoutingProfileAction } from '../routingProfile.action';

export const RoutingProfileListSubscriber: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(RoutingProfileAction.loadList.started());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(RoutingProfileAction.destroy());
    };
  }, [dispatch]);

  return null;
};
